import script from "./SectionImprovePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionImprovePanel.vue?vue&type=script&setup=true&lang=js"

import "./SectionImprovePanel.vue?vue&type=style&index=0&id=dd858268&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd858268"]])

export default __exports__